// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__E5pWu","content":"styles_content__3iuqX","tableWrap":"styles_tableWrap__1E9FS"};